export default __webpack_public_path__ + "2f5476ec293477190100b3882c9423e1.svg";